import React, { useState } from 'react';
import Classes from './styles/style.module.css';
import { motion } from 'framer-motion';
import { usePreventScrolling } from '../../../Hooks/usePreventScrolling';
import { CloseIcon } from '../../../utils/Icons';

export default function FleetMembPopup({ closePopup, submitPopup }) {
  const [vehicles, setVehicles] = useState(1);
  const [notes, setNotes] = useState("");

  const handleBgClick = () => closePopup();
  const handleCardClick = (e) => e.stopPropagation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const v = Math.max(1, Number(vehicles || 1));
    submitPopup(v, notes); // ✅ now sends notes too
  };

  usePreventScrolling();

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        className={Classes.popup}
        onClick={handleBgClick}
      >
        <motion.div
          initial={{ y: 7 }} animate={{ y: 0 }} exit={{ y: 7 }}
          transition={{ duration: 0.25 }}
          className={Classes.card}
          onClick={handleCardClick}
        >
          <div className={Classes.close} onClick={closePopup}>
            <CloseIcon height='20px' fill='white' />
          </div>

          <div className={Classes.bgPopup}>
            <div />
            <h5 className={Classes.title}> Fleet Membership </h5>
            <div className={Classes.curveCon} />
          </div>

          <form onSubmit={handleSubmit}>
            <div className={Classes.cardCon}>

              <div className={Classes.flexColGroup}>
                <div className={Classes.flexCol1}>
                  <h5 className={Classes.fleetSize}>Number of Fleet Vehicles</h5>
                  <input
                    type="number"
                    min={1}
                    value={vehicles}
                    onChange={(e) => setVehicles(e.target.value)}
                    className={Classes.input}
                    placeholder="e.g., 10"
                    required
                  />
                  <h5 className={Classes.hint}>
                    Fleet is billed <b>per vehicle / month</b>. <br />
                    Setup fee can be applied (or removed) after admin approval.
                  </h5>
                </div>
              </div>

              {/* OPTIONAL message (your original textarea block but enabled) */}
              <div className={Classes.flexColGroup}>
                <div className={Classes.flexCol1}>
                  <div className={Classes.textAreaCon}>
                    <textarea
                      rows={4}
                      name="notes"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder="Message (Optional)"
                    />
                  </div>
                </div>
              </div>

              <div className={Classes.flexAlign}>
                <button type="button" onClick={closePopup} className={Classes.btn1}>
                  <h5> Back </h5>
                </button>
                <button type="submit" className={Classes.btn2}>
                  <h5> Continue </h5>
                </button>
              </div>

            </div>
          </form>
        </motion.div>
      </motion.div>
    </>
  );
}
